import { useEffect } from 'react';
import HeroSection, { FIELD_RGB as HERO_FILL } from './home/HeroSection';
import AboutSection, { FIELD_RGB as ABOUT_FILL } from './home/AboutSection';
import HomeCSSection from './home/HomeCSSection';

export default function Home() {
    // Scroll snapping lives on <html> because the document is the scroll container, so
    // it has to be switched on and off with this page rather than declared in the
    // markup. See `.snap-page` in index.css.
    useEffect(() => {
        document.documentElement.classList.add('snap-page');
        return () => document.documentElement.classList.remove('snap-page');
    }, []);

    return (
        <div className="bg-gray-900 text-[#0008ff]">
            {/* data-header-fill washes the header with each screen's own field rather
                than with black — see page_assets/header. Plain wrappers, so neither
                section's sticky track is disturbed. */}
            <div data-header-fill={HERO_FILL}>
                <HeroSection />
            </div>
            {/* The CS run sits between the landing and the contact screen, so the work
                is read on the way to the links rather than behind one of them. The
                /cs-portfolio page is unchanged — this is the same run shown twice. */}
            <HomeCSSection />
            <div data-header-fill={ABOUT_FILL}>
                <AboutSection />
            </div>
        </div>
    );
}
